module.exports = __webpack_public_path__ + "img/pexels-dids-5360447.9441cdaf.jpg";